<template>
    <Modal size="m" :onClose="onEditClick">
        <div class="duplicate-pax-warning">
            <Icon type="InfoCircle" size="auto" class="duplicate-pax-warning-icon" />

            <div class="duplicate-pax-warning-content">
                <span class="duplicate-pax-warning-content-title">
                    {{
                        t({
                            key: 'warning.pax.more_than_one_passenger_has_the_same_name',
                        })
                    }}
                </span>
                {{
                    t({
                        key: 'warning.pax.please_review_and_make_necessary_changes',
                    })
                }}
            </div>
            <div class="duplicate-pax-warning-button">
                <ButtonPrimary :onClick="onEditClick">
                    {{ t({ key: 'warning.pax.edit_names' }) }}
                </ButtonPrimary>
            </div>
        </div>
    </Modal>
</template>

<script lang="ts">
    import { defineComponent, onMounted, PropType } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { isEmpty } from 'lodash';
    import { logStatsigCheckoutDuplicatePaxWarningOpen } from '@/tracking/statsig/checkout.functions';
    import { scrollToElement } from '@shared/helpers/scroll';
    import { trackClarity } from '@/tracking/clarity';
    import { ClarityEvent } from '@/tracking/clarity/types';
    import { FlightPax } from '@/api/Cart/cart.interfaces';
    import ButtonPrimary from '@ui/components/Button/ButtonPrimary.vue';
    import Modal from '@ui/components/Modal/Modal.vue';
    import Icon from '@ui/components/Icon/Icon.vue';

    export default defineComponent({
        name: 'DuplicatePaxWarning',
        methods: { t },
        components: { ButtonPrimary, Modal, Icon },
        props: {
            onClose: { type: Function, required: true },
            pax: {
                type: Object as PropType<Record<string, FlightPax[]>>,
                required: true,
            },
        },
        setup(props) {
            onMounted(() => {
                trackClarity(ClarityEvent.CHECKOUT_DUPLICATE_PAX_WARNING);
                const names = isEmpty(props.pax)
                    ? []
                    : Object.values(props.pax)
                          .flat()
                          .map((p) => `${p.FirstName} ${p.LastName}`);
                logStatsigCheckoutDuplicatePaxWarningOpen(names.length);
            });
            const scrollDuplicateInput = () => {
                const productId = Object.keys(props.pax)?.[0];

                if (!productId || isEmpty(props.pax[productId])) return;

                const { FirstName } = props.pax[productId][0];

                const secondInput = document
                    .querySelector(`form[id*="${productId}"]`)
                    ?.querySelectorAll(`input[value="${FirstName}"]`)[1];

                if (secondInput) scrollToElement(secondInput, -20, true);
            };

            const onEditClick = () => {
                props.onClose && props.onClose();
                scrollDuplicateInput();
            };

            return {
                onEditClick,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'DuplicatePaxWarning';
</style>
